module.exports = require("!!../../../../webpack/loaders/wrap.js?{\"before\":\"(function(require, define) {\",\"after\":\"}(function require(id) { throw new Error(\\\"Invalid dynamic require\\\"); }, function define(id) { throw new Error(\\\"Invalid dynamic define\\\"); }));\"}!./browsers.js");


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode-css-languageservice/src/data/browsers.js
// module id = 571
// module chunks = 0